import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { FormattedMessage, useIntl } from "react-intl";
import Loader from "components/shared/Loader";
import { Input } from "components/shared/FormComponents";
import AddButton from "components/shared/AddButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import { useState } from "react";
import ReactSelect from "react-select";
import { getId } from "helpers/functions";
import { addSocial, getAllSocialTypes } from "store/actions";

const AddSocials = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState({
    preview: null,
    path: "",
  });
  const { loading, error } = useSelector((state) => state.socials);
  const { socialTypes } = useSelector((state) => state.socialTypes);

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm();

  useEffect(() => {
    if (socialTypes?.length === 0) {
      dispatch(getAllSocialTypes());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const renderCategoriesOptions = socialTypes?.map((item) => (
    <option value={getId(item)}>{item?.name?.[locale]}</option>
  ));

  const onSubmit = (data) => {
    dispatch(addSocial({ data, navigate }));
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"addSocial"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={8} md={12}>
                <Col xs={12}>
                  <div className="form-group required">
                    <h5>نوع وسيلة التواصل</h5>
                    <div>
                      <select
                        className="form-control"
                        {...register("socialType", { required: true })}
                      >
                        <option>اختر التصنيف</option>
                        {renderCategoriesOptions}
                      </select>
                    </div>
                    <p className="error-hint">
                      {errors.socialType?.type === "required" && (
                        <FormattedMessage id="required" />
                      )}
                    </p>
                  </div>
                </Col>
                {/* name  */}
                <Row>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="name"
                      name="name"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="link"
                      name="link"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                </Row>

                <AddButton />
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddSocials;
